<template>
  <div>

    <div class="my-container" style="position: relative;">
      <h2>Dataset details</h2>
      <el-image :src="icon_path" v-on:click="showOrHide"
                style="position: absolute;width: 40px;height:40px;right: 10px;top:5px;z-index: 9999"/>
      <div v-show="showDatasetDetails" style="margin: 1px">
        <el-table
            :data="datasetDetails"
            :header-cell-style="{margin: '0',padding: '0', color: 'black'}"
            :cell-style="{margin: '0',padding: '0', color: 'black'}"
            stripe
            border>
          <el-table-column
              prop="title"
              label="title"
              min-width="30px">
          </el-table-column>
          <el-table-column
              prop="content"
              label="content">
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!--RCTD -->
    <div v-if="haveRCTD === true||haveSPOTLight === true">
      <div v-for="(item,index) in RCTD" :key="index">
        <div class="my-container">
          <h2 v-if="index===0">Deconvolution</h2>
          <!--label-->
          <h3 style="text-align: left;margin-left: 10px;">* {{item.name}}</h3>
          <!--图片-->
          <div :id='"rctd_pic"+index'>
            <div v-if="item.num === 1">
              <img :src=item.path[0] class="pic" width="50%" @error="rctd_pic_error(index, item.name)" alt="no img">
            </div>
            <div v-else-if="item.num === 2">
              <div  class="my-div-center">
                <img :src=item.path[0] width="50%" class="pic" @error="rctd_pic_error(index, item.name)" alt="no img">
                <img :src=item.path[1] width="50%" class="pic" @error="rctd_pic_error(index, item.name)" alt="no img">
              </div>
            </div>
            <div v-else-if="item.num === 3">
              <div  class="my-div-center">
                <img :src=item.path[0] width="33%" class="pic" @error="rctd_pic_error(index, item.name)" alt="no img">
                <img :src=item.path[1] width="33%" class="pic" @error="rctd_pic_error(index, item.name)" alt="no img">
                <img :src=item.path[2] width="33%" class="pic" @error="rctd_pic_error(index, item.name)" alt="no img">
              </div>
            </div>
            <div v-else>
              no img
            </div>
          </div>
          <div :id="'rctd_svg'+index" style="display:none;">
            <svg :id="'mySVG'+index" height="500px" width="500px" style="border:2px solid #aaaaaa;"/>
          </div>
          <div :id="'rctd_vue'+index" style="height: 600px;"/>
          <!-- table-->
          <el-table
              :data="item.data.slice((pageinfo[index].currentPage-1)*pageinfo[index].pageSize,pageinfo[index].currentPage*pageinfo[index].pageSize)"
              :row-style="{height: '30px'}"
              :cell-style="{padding: '0', color: 'black', margin: '0'}"
              :header-cell-style="{padding: '0', margin: '0', fontSize: '10px', color: 'black'}">
            <el-table-column prop="spot" label="spot" width="200" sortable show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="b_cells" label="B.cells" sortable :formatter="rounding" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="cafs" label="CAFs" sortable :formatter="rounding" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="cancer_Epithelial" label="Cancer.Epithelial" width="150" sortable :formatter="rounding" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="endothelial" label="Endothelial" sortable :formatter="rounding" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="myeloid" label="Myeloid" sortable :formatter="rounding" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="normal_Epithelial" label="Normal.Epithelial" width="150" sortable :formatter="rounding" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="pvl" label="PVL" sortable :formatter="rounding" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="t_cells" label="T.cells" sortable :formatter="rounding" show-overflow-tooltip>
            </el-table-column>
          </el-table>
          <!-- 分页器 -->
          <div v-if="index===0">
            <el-pagination align='center' @size-change="handleSizeChange0" @current-change="handleCurrentChange0"
                           :current-page="pageinfo[index].currentPage"
                           :page-sizes="[1,5,10,20]"
                           :page-size="pageinfo[index].pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="item.data.length">
            </el-pagination>
          </div>
          <div v-if="index===1">
            <el-pagination align='center' @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
                           :current-page="pageinfo[index].currentPage"
                           :page-sizes="[1,5,10,20]"
                           :page-size="pageinfo[index].pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="item.data.length">
            </el-pagination>
          </div>
          <div v-if="index===2">
            <el-pagination align='center' @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
                           :current-page="pageinfo[index].currentPage"
                           :page-sizes="[1,5,10,20]"
                           :page-size="pageinfo[index].pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="item.data.length">
            </el-pagination>
          </div>
          <div v-if="index===3">
            <el-pagination align='center' @size-change="handleSizeChange3" @current-change="handleCurrentChange3"
                           :current-page="pageinfo[index].currentPage"
                           :page-sizes="[1,5,10,20]"
                           :page-size="pageinfo[index].pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="item.data.length">
            </el-pagination>
          </div>
          <div v-if="index===4">
            <el-pagination align='center' @size-change="handleSizeChange4" @current-change="handleCurrentChange4"
                           :current-page="pageinfo[index].currentPage"
                           :page-sizes="[1,5,10,20]"
                           :page-size="pageinfo[index].pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="item.data.length">
            </el-pagination>
          </div>
          <div v-if="index===5">
            <el-pagination align='center' @size-change="handleSizeChange5" @current-change="handleCurrentChange5"
                           :current-page="pageinfo[index].currentPage"
                           :page-sizes="[1,5,10,20]"
                           :page-size="pageinfo[index].pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="item.data.length">
            </el-pagination>
          </div>
          <div v-if="index===6">
            <el-pagination align='center' @size-change="handleSizeChange6" @current-change="handleCurrentChange6"
                           :current-page="pageinfo[index].currentPage"
                           :page-sizes="[1,5,10,20]"
                           :page-size="pageinfo[index].pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="item.data.length">
            </el-pagination>
          </div>
          <div v-if="index===7">
            <el-pagination align='center' @size-change="handleSizeChange7" @current-change="handleCurrentChange7"
                           :current-page="pageinfo[index].currentPage"
                           :page-sizes="[1,5,10,20]"
                           :page-size="pageinfo[index].pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="item.data.length">
            </el-pagination>
          </div>
          <div v-if="index===8">
            <el-pagination align='center' @size-change="handleSizeChange8" @current-change="handleCurrentChange8"
                           :current-page="pageinfo[index].currentPage"
                           :page-sizes="[1,5,10,20]"
                           :page-size="pageinfo[index].pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="item.data.length">
            </el-pagination>
          </div>
          <div v-if="index===9">
            <el-pagination align='center' @size-change="handleSizeChange9" @current-change="handleCurrentChange9"
                           :current-page="pageinfo[index].currentPage"
                           :page-sizes="[1,5,10,20]"
                           :page-size="pageinfo[index].pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="item.data.length">
            </el-pagination>
          </div>
        </div>

      </div>
    </div>

    <!--Celltype Annotation -->
    <div v-if="haveClassification!==false||haveMajor!==false||haveMinor!==false||haveSubset!==false||haveAnnotation!==false">
      <div class="my-container">
        <h2>Celltype Annotation</h2>
        <template v-if="haveAnnotation===true">
          <div v-for="(item,index) in annotation" :key="index">
            <template v-if="item.num !== 0">
              <template v-if="item.num === 1">
                <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}(lable transfer)</h3>
                <img :src=item.path[0] width="70%"  alt="pic load error">
              </template>
              <template v-else-if="item.num === 2">
                <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}(lable transfer)</h3>
                <div  class="my-div-center">
                  <img :src=item.path[0] width="70%"  alt="pic load error">
                </div>
                <div  class="my-div-center">
                  <img :src=item.path[1] width="70%"  alt="pic load error">
                </div>
              </template>
              <template v-else-if="item.num === 3">
                <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}(lable transfer)</h3>
                <div  class="my-div-center">
                  <img :src=item.path[0] width="33%"  alt="pic load error">
                </div>
                <div  class="my-div-center">
                  <img :src=item.path[1] width="70%"  alt="pic load error">
                </div>
                <div  class="my-div-center">
                  <img :src=item.path[2] width="70%"  alt="pic load error">
                </div>
              </template>
            </template>
          </div>
        </template>
        <div v-if="haveClassification!==false||haveMajor!==false||haveMinor!==false||haveSubset!==false">
          <el-tabs
              ref="tabs1"
              v-model="activeName1"
              stretch
              @tab-click="handleClick"
              style="margin-top: 10px" >
            <el-tab-pane label="Ground truth" name="first1" v-if="haveClassification!==false">
              <div v-for="(item,index) in classification" :key="index">
                <div v-if="item.num !==0">
                  <h3 style="text-align: left;margin-left: 10px">* {{item.name}}</h3>
                </div>
                <div v-if="item.num ===1">
                  <div  class="my-div-center">
                    <img :src=item.path[0] width="50%"  alt="pic load error">
                  </div>
                  <div  class="my-div-center" style="margin: 0;padding: 0">
                    <p style="width: 100%">classification</p>
                  </div>
                </div>
                <div v-if="item.num ===2">
                  <div  class="my-div-center">
                    <img :src=item.path[0] width="50%"  alt="pic load error">
                    <img :src=item.path[1] width="50%"  alt="pic load error">
                  </div>
                  <div  class="my-div-center" style="margin: 0;padding: 0">
                    <p style="width: 50%">classification1</p>
                    <p style="width: 50%">classification2</p>
                  </div>
                </div>
                <div v-if="item.num ===3">
                  <div  class="my-div-center">
                    <img :src=item.path[0] width="33%"  alt="pic load error">
                    <img :src=item.path[1] width="33%"  alt="pic load error">
                    <img :src=item.path[2] width="33%"  alt="pic load error">
                  </div>
                  <!--                    <div  class="my-div-center" style="margin: 0;padding: 0">-->
                  <!--                      <p style="width: 33%">classification1</p>-->
                  <!--                      <p style="width: 33%">classification2</p>-->
                  <!--                      <p style="width: 33%">classification3</p>-->
                  <!--                    </div>-->
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="Label transfer" name="second1" v-if="haveMajor===true||haveMinor===true||haveSubset===true">
              <template v-if="haveMajor!==false||haveMinor!==false||haveSubset!==false">
                <template v-if="Label_transfer === 1">
                  <template v-if="haveMajor===true">
                    <div v-for="(item,index) in major" :key="index">
                      <div v-if="item.num !== 0">
                        <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}</h3>
                      </div>
                      <div v-if="item.num === 1">
                        <div  class="my-div-center">
                          <img :src=item.path[0] width="70%"  alt="pic load error">
                        </div>
                      </div>
                      <div v-if="item.num === 2">
                        <div  class="my-div-center">
                          <img :src=item.path[0] width="40%"  alt="pic load error">
                          <img :src=item.path[1] width="40%"  alt="pic load error">
                        </div>
                      </div>
                      <div v-if="item.num === 3">
                        <div  class="my-div-center">
                          <img :src=item.path[0] width="33%"  alt="pic load error">
                          <img :src=item.path[1] width="33%"  alt="pic load error">
                          <img :src=item.path[2] width="33%"  alt="pic load error">
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="haveMinor===true">
                    <div v-for="(item,index) in minor" :key="index">
                      <div v-if="item.num !== 0">
                        <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}</h3>
                      </div>
                      <div v-if="item.num === 1">
                        <div  class="my-div-center">
                          <img :src=item.path[0] width="70%"  alt="pic load error">
                        </div>
                      </div>
                      <div v-if="item.num === 2">
                        <div  class="my-div-center">
                          <img :src=item.path[0] width="40%"  alt="pic load error">
                          <img :src=item.path[1] width="40%"  alt="pic load error">
                        </div>
                      </div>
                      <div v-if="item.num === 3">
                        <div  class="my-div-center">
                          <img :src=item.path[0] width="33%"  alt="pic load error">
                          <img :src=item.path[1] width="33%"  alt="pic load error">
                          <img :src=item.path[2] width="33%"  alt="pic load error">
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="haveSubset===true">
                    <div v-for="(item,index) in subset" :key="index">
                      <div v-if="item.num !== 0">
                        <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}</h3>
                      </div>
                      <div v-if="item.num === 1">
                        <div  class="my-div-center">
                          <img :src=item.path[0] width="70%"  alt="pic load error">
                        </div>
                      </div>
                      <div v-if="item.num === 2">
                        <div  class="my-div-center">
                          <img :src=item.path[0] width="40%"  alt="pic load error">
                          <img :src=item.path[1] width="40%"  alt="pic load error">
                        </div>
                      </div>
                      <div v-if="item.num === 3">
                        <div  class="my-div-center">
                          <img :src=item.path[0] width="33%"  alt="pic load error">
                          <img :src=item.path[1] width="33%"  alt="pic load error">
                          <img :src=item.path[2] width="33%"  alt="pic load error">
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
                <template v-else>
                  <template v-if="haveMajor===true">
                    <div class="my-container">
                      <h2>celltype_major</h2>
                      <div v-for="(item,index) in major" :key="index">
                        <div v-if="item.num !== 0">
                          <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}</h3>
                        </div>
                        <div v-if="item.num === 1">
                          <div  class="my-div-center">
                            <img :src=item.path[0] width="70%"  alt="pic load error">
                          </div>
                        </div>
                        <div v-if="item.num === 2">
                          <div  class="my-div-center">
                            <img :src=item.path[0] width="40%"  alt="pic load error">
                            <img :src=item.path[1] width="40%"  alt="pic load error">
                          </div>
                        </div>
                        <div v-if="item.num === 3">
                          <div  class="my-div-center">
                            <img :src=item.path[0] width="33%"  alt="pic load error">
                            <img :src=item.path[1] width="33%"  alt="pic load error">
                            <img :src=item.path[2] width="33%"  alt="pic load error">
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="haveMinor===true">
                    <div class="my-container">
                      <h2>celltype_minor</h2>
                      <div v-for="(item,index) in minor" :key="index">
                        <div v-if="item.num !== 0">
                          <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}</h3>
                        </div>
                        <div v-if="item.num === 1">
                          <div  class="my-div-center">
                            <img :src=item.path[0] width="70%"  alt="pic load error">
                          </div>
                        </div>
                        <div v-if="item.num === 2">
                          <div  class="my-div-center">
                            <img :src=item.path[0] width="40%"  alt="pic load error">
                            <img :src=item.path[1] width="40%"  alt="pic load error">
                          </div>
                        </div>
                        <div v-if="item.num === 3">
                          <div  class="my-div-center">
                            <img :src=item.path[0] width="33%"  alt="pic load error">
                            <img :src=item.path[1] width="33%"  alt="pic load error">
                            <img :src=item.path[2] width="33%"  alt="pic load error">
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="haveSubset===true">
                    <div class="my-container">
                      <h2>celltype_subset</h2>
                      <div v-for="(item,index) in subset" :key="index">
                        <div v-if="item.num !== 0">
                          <h3 style="text-align: left;margin-left: 10px;position: absolute">* {{item.name}}</h3>
                        </div>
                        <div v-if="item.num === 1">
                          <div  class="my-div-center">
                            <img :src=item.path[0] width="70%"  alt="pic load error">
                          </div>
                        </div>
                        <div v-if="item.num === 2">
                          <div  class="my-div-center">
                            <img :src=item.path[0] width="40%"  alt="pic load error">
                            <img :src=item.path[1] width="40%"  alt="pic load error">
                          </div>
                        </div>
                        <div v-if="item.num === 3">
                          <div  class="my-div-center">
                            <img :src=item.path[0] width="33%"  alt="pic load error">
                            <img :src=item.path[1] width="33%"  alt="pic load error">
                            <img :src=item.path[2] width="33%"  alt="pic load error">
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
              </template>
              <div v-else>No data</div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>

    <!--Cell-cell interaction -->
    <div v-if="haveMIF!==false || haveCommunication!==false || haveInteraction!==false">
      <div class="my-container">
        <h2>Cell-cell interaction</h2>
        <template v-if="haveInteraction === true">
          <div v-for="(item,index) in interaction" :key="index">
            <div v-if="item.num !== 0">
              <div v-if="item.num === 1">
                <h3 style="text-align: left;margin-left: 10px; position: absolute">* {{item.name}}</h3>
                <img :src=item.path[0] width="40%"  alt="pic load error">
              </div>
              <div v-else-if="item.num === 2">
                <h3 style="text-align: left;margin-left: 10px; position: absolute">* {{item.name}}</h3>
                <div  class="my-div-center">
                  <img :src=item.path[0] width="50%"  alt="pic load error">
                </div>
                <div  class="my-div-center">
                  <img :src=item.path[1] width="50%"  alt="pic load error">
                </div>
              </div>
              <div v-else-if="item.num === 3">
                <h3 style="text-align: left;margin-left: 10px; position: absolute">* {{item.name}}</h3>
                <div  class="my-div-center">
                  <img :src=item.path[0] width="50%"  alt="pic load error">
                </div>
                <div  class="my-div-center">
                  <img :src=item.path[1] width="50%"  alt="pic load error">
                </div>
                <div  class="my-div-center">
                  <img :src=item.path[2] width="50%"  alt="pic load error">
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-if="haveMIF === true">
          <h3>MIF</h3>
          <div v-for="(item,index) in MIF" :key="index">
            <div v-if="item.num !== 0">
              <div v-if="item.num === 1">
                <h3 style="text-align: left;margin-left: 10px; position: absolute">* {{item.name}}</h3>
                <img :src=item.path[0] width="40%"  alt="pic load error">
              </div>
              <div v-else-if="item.num === 2">
                <h3 style="text-align: left;margin-left: 10px; position: absolute">* {{item.name}}</h3>
                <img :src=item.path[0] width="50%"  alt="pic load error">
                <img :src=item.path[1] width="50%"  alt="pic load error">
              </div>
              <div v-else-if="item.num === 3">
                <h3 style="text-align: left;margin-left: 10px; position: absolute">* {{item.name}}</h3>
                <img :src=item.path[0] width="33%"  alt="pic load error">
                <img :src=item.path[1] width="33%"  alt="pic load error">
                <img :src=item.path[2] width="33%"  alt="pic load error">
              </div>
            </div>
          </div>
        </template>

        <template v-if="haveCommunication === true">
          <div v-for="(item,index) in communication" :key="index">
            <div v-if="item.num !== 0">
              <div v-if="item.num === 1">
                <h3 style="text-align: left;margin-left: 10px; position: absolute">* {{item.name}}</h3>
                <img :src=item.path[0] width="40%"  alt="pic load error">
              </div>
              <div v-else-if="item.num === 2">
                <h3 style="text-align: left;margin-left: 10px; position: absolute">* {{item.name}}</h3>
                <img :src=item.path[0] width="50%"  alt="pic load error">
                <img :src=item.path[1] width="50%"  alt="pic load error">
              </div>
              <div v-else-if="item.num === 3">
                <h3 style="text-align: left;margin-left: 10px; position: absolute">* {{item.name}}</h3>
                <img :src=item.path[0] width="33%"  alt="pic load error">
                <img :src=item.path[1] width="33%"  alt="pic load error">
                <img :src=item.path[2] width="33%"  alt="pic load error">
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>

</template>

<script>
import * as echarts from "echarts/core";

export default {
  name: "CellType",
  data() {
    return{
      datasetDetails: [],
      showDatasetDetails: false,
      icon_path: require('../../assets/show.png'),
      activeName1: 'first1',
      // activeName2: 'first2',
      haveRCTD: false,
      RCTD: [],
      list_data: {
        normal_Epithelial: [],
        cancer_Epithelial: [],
        endothelial: [],
        pvl: [],
        plasmablasts: [],
        myeloid: [],
        t_cells: [],
        cafs: [],
        b_cells: []
      },
      type: 'normal_Epithelial',
      type2: [
        "normal_Epithelial",
        "cancer_Epithelial",
        "endothelial",
        "pvl",
        "plasmablasts",
        "myeloid",
        "t_cells",
        "cafs",
        "b_cells"
      ],
      color2: [
        "#43CD80",
        "#FFDAB9",
        "#FFFF00",
        "#D8BFD8",
        "#436EEE",
        "#FF3E96",
        "#CD8162",
        "#90EE90",
        "#9ACD32",
        "#CD69C9",
        "#CD2990",
        "#2E8B57",
        "#32CD32",
        "#EEC900"
      ],
      position: [],
      haveSPOTLight: false,
      SPOTLight: [],
      pageinfo: [
        {
          currentPage: 1,
          pageSize: 10,
        },
        {
          currentPage: 1,
          pageSize: 10,
        },
        {
          currentPage: 1,
          pageSize: 10,
        },
        {
          currentPage: 1,
          pageSize: 10,
        },
        {
          currentPage: 1,
          pageSize: 10,
        },
        {
          currentPage: 1,
          pageSize: 10,
        },
        {
          currentPage: 1,
          pageSize: 10,
        },
        {
          currentPage: 1,
          pageSize: 10,
        },
        {
          currentPage: 1,
          pageSize: 10,
        },
        {
          currentPage: 1,
          pageSize: 10,
        },
        {
          currentPage: 1,
          pageSize: 10,
        }
      ],
      // currentPage1: 1,
      // pageSize1: 10,
      // currentPage:[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
      // pageSize:[10,10,10,10,10,10,10,10,10,10,10,10,10,10,10],
      // handleSizeChange: ['handleSizeChange1','handleSizeChange2','handleSizeChange3','handleSizeChange4','handleSizeChange5',
      //   'handleSizeChange6','handleSizeChange7','handleSizeChange8','handleSizeChange9','handleSizeChange10'],
      // handleCurrentChange: ['handleCurrentChange1','handleCurrentChange2','handleCurrentChange3','handleCurrentChange4','handleCurrentChange5',
      //   'handleCurrentChange6','handleCurrentChange7','handleCurrentChange8','handleCurrentChange9','handleCurrentChange10'],
      // currentPage1: 1, // 当前页码
      // total1: 100, // 总条数
      // pageSize1: 10, // 每页的数据条数
      haveClassification: false,
      haveCommunication: false,
      haveMIF: false,
      Label_transfer: 0,
      haveMajor: false,
      haveMinor: false,
      haveSubset: false,
      haveAnnotation: false,
      haveInteraction: false,
      classification: [],
      communication: [],
      MIF: [],
      major: [],
      minor: [],
      subset: [],
      annotation: [],
      interaction: []

    }
  },
  mounted() {
    this.getDatasetInformation()
    this.getRCTD()
    this.getImg()
  },
  methods: {
    getDatasetInformation() {
      let _this = this
      // console.log(_this.$route.params.id)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/dataset/'+ _this.$route.params.id)
          .then(function (response){
            console.log('dataset:')
            console.log(response)
            _this.datasetDetails = response.data.details
          })
    },
    showOrHide() {
      console.log("before:"+this.showDatasetDetails)
      if (this.showDatasetDetails === false){
        this.showDatasetDetails = true
        this.icon_path = require('../../assets/hide.png')
        // this.datasetDetail_tip = 'hide'
      }else {
        this.showDatasetDetails = false
        this.icon_path = require('../../assets/show.png')
        // this.datasetDetail_tip = 'show'
      }
      console.log("after:"+this.showDatasetDetails)
    },
    getRCTD(){
      let _this = this
      // console.log(_this.$route.params.id)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/celltype/haveRCTD/'+ _this.$route.params.id)
          .then(function (response){
            console.log('haveRCTD:')
            console.log(response)
            _this.haveRCTD = response.data
            console.log("this.haveRCTD:" + _this.haveRCTD)
            if(_this.haveRCTD){
              _this.$axios.get(
                  'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/celltype/RCTD/'+ _this.$route.params.id)
                  .then(function (response){
                    console.log('RCTD:')
                    _this.RCTD = response.data.rctd
                    console.log(_this.RCTD)
                    setTimeout(
                        function (){
                          for (let temp = 0; temp < _this.RCTD.length; temp++) {
                            _this.initEcharts(temp, _this.RCTD[temp].name)
                          }
                        },
                        1000,
                    )
                  })
            }else {
              _this.$axios.get(
                  'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/celltype/haveSPOTLight/'+ _this.$route.params.id)
                  .then(function (response){
                    console.log('haveSPOTLight:')
                    console.log(response)
                    _this.haveSPOTLight = response.data
                    console.log("this.haveSPOTLight:" + _this.haveSPOTLight)
                    if(_this.haveSPOTLight){
                      _this.$axios.get(
                          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/celltype/SPOTLight/'+ _this.$route.params.id)
                          .then(function (response){
                            console.log('SPOTLight:')
                            console.log(response)
                            // _this.RCTD = response.data.spotlight
                            // _this.RCTD.data = []
                          })
                    }
                  })
            }

          })
    },
    getImg(){
      let _this = this
      // console.log(_this.$route.params.id)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/celltype/img/'+ _this.$route.params.id)
          .then(function (response){
            console.log('img:')
            console.log(response)
            _this.classification = response.data.classification
            _this.communication = response.data.communication
            _this.MIF = response.data.MIF
            _this.major = response.data.major
            _this.minor = response.data.minor
            _this.subset = response.data.subset
            _this.annotation = response.data.annotation
            _this.interaction = response.data.interaction
            _this.isImgExist()
          })
    },
    get_RCTD_position(index, name){
      let _this = this
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/celltype/position/'+ _this.$route.params.id+'/'+ name)
          .then(function (response){
            console.log(response)
            let x_norm = _this.normalization(response.data.x)
            let y_norm = _this.normalization(response.data.y)
            let res = {'x': x_norm, 'y': y_norm}
            console.log(response.data)
            console.log(res)
            _this.position.push(res)
            // console.log(_this.position)
            setTimeout(
                function (){
                  _this.createPie(index)
                  _this.createIntroduction2(index)
                },
                1000,
            )
          })
    },
    rctd_pic_error(index, name){
      console.log(index, name)
      document.getElementById('rctd_pic'+index).style.display = "none"
      document.getElementById('rctd_svg'+index).style.display = "block"
      this.get_RCTD_position(index, name)
    },
    createPie(index){
      let _this = this
      let elementID = "mySVG"+index
      var svgDoc = document.getElementById(elementID);
      let x = _this.position[index].x
      let y = _this.position[index].y
      for (let temp in _this.RCTD[index].data) {
        let count = 0
        let temp_array = _this.RCTD[index].data[temp]
        // console.log(_this.RCTD[index].data[temp])
        for (let j in _this.type2){
          let name = _this.type2[j]
          // console.log(_this.type2[j])
          let per = Number(temp_array[name])
          // console.log(per)
          if (per !== 0){
            let c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
            // console.log(temp, x[temp])
            c.setAttribute('cx', Number((x[temp])*450));
            c.setAttribute('cy',  Number((y[temp])*450));
            c.setAttribute('r',3)
            c.setAttribute('stroke', this.color2[j])
            c.setAttribute('fill', 'transparent')
            c.setAttribute('stroke-width', 6)
            c.setAttribute('stroke-dasharray', per*100 +' 20')
            let off = Number('-' + count)
            c.setAttribute('stroke-dashoffset', off*100)
            count = per + count
            // console.log('name: '+name)
            // console.log('x: '+Number(temp.x)*17)
            // console.log('y: '+Number((temp.y)*17))
            // console.log('color: '+this.color2[j])
            // console.log('offset: '+off)
            // console.log('per: '+per)
            // console.log('count: '+count)
            // stroke-dasharray
            // stroke-dashoffset

            // c.addEventListener("mouseover", function() {
            //   let c_temp = c
            //   var title = document.createElementNS("http://www.w3.org/2000/svg","title");
            //   var text = document.createTextNode("x:"+array[i].x+"\ny:"+array[i].y+"\nexpression:"+array[i].celltype);
            //   title.appendChild(text);
            //   c_temp.setAttribute("r",10);
            //   c_temp.appendChild(title);
            // })

            // c.addEventListener("mouseleave", function() {
            //   c.setAttribute("r",5);
            // })
            svgDoc.appendChild(c);
          }

        }
        // break
      }
    },
    createIntroduction2(index) {
      let elementID = "mySVG"+index
      var svgDoc = document.getElementById(elementID);
      let w = 10
      let h = 10
      for (let i in this.type2) {
        // console.log(i)
        // console.log(array[i].x)
        // console.log(array[i].y)
        // console.log(array[i].expression)
        let temp_w = w + 5
        let temp_h = h + 20*i
        let c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        c.setAttribute('cx', w);
        c.setAttribute('cy',  temp_h);
        c.setAttribute('r',10);
        c.setAttribute('fill', this.color2[i]);
        svgDoc.appendChild(c);
        let t = document.createElementNS('http://www.w3.org/2000/svg','text');
        //
        t.setAttribute('x', temp_w+5);
        t.setAttribute('y',  temp_h+5);
        t.setAttribute("font-size", "20");
        t.setAttribute('fill', 'green');
        t.innerHTML = this.type2[i];
        svgDoc.appendChild(t);
      }


      // // 添加文本
      // var t = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      // t.setAttribute("x", parseInt(data.x) + 5);
      // t.setAttribute("y", parseInt(data.y) + 10);
      // t.setAttribute("font-size", "20");
      // t.setAttribute('fill', 'green');
      // t.addEventListener("click", function() {
      //   alert('文本点击测试：' + data.nodeText);
      // });
      // t.addEventListener("mouseover", function() {
      //   console.log('文本鼠标悬停测试：' + data.nodeText);
      // });
      // t.innerHTML = data.nodeText;
      // svgDoc.appendChild(t);

    },
    initEcharts(index, name){
      console.log(index)
      this.changeJSONObject2Array(index,name)
      let _this = this
      let elementID = "rctd_vue"+index
      console.log(elementID)
      const chartDom = document.getElementById(elementID);
      const myChart = echarts.init(chartDom);
      let option;
      const schema = [
        { name: 'no', index: 0, text: 'no' },
        { name: 'x', index: 1, text: 'x' },
        { name: 'y', index: 2, text: 'y' },
        { name: 'spot', index: 3, text: 'spot' },
        { name: 'expression', index: 4, text: 'expression' },
      ];
      const itemStyle = {
        // opacity: 0.8,
        // shadowBlur: 10,
        // shadowOffsetX: 0,
        // shadowOffsetY: 0,
        // shadowColor: 'rgba(0,0,0,0.3)',
        emphasis: {
          focus : 'self'
        }
      };
      option = {
        color: ['#FF0000', '#FF8000', '#FFFF00', '#80FF00', '#00FF00', '#00FF80', '#00FFFF',
          '#0080FF', '#0000FF', '#7F00FF', '#FF00FF', '#FF007F', '#808080', '#FF7F7F'],
        legend: {
          // orient: 'vertical',
          x: 'center',
          y: 'top',
          // top: 10,
          padding: [
            5,  // 上
            10, // 右
            5,  // 下
            10, // 左
          ],
          data:
              ["normal_Epithelial",
                "cancer_Epithelial",
                "endothelial",
                "pvl",
                "plasmablasts",
                "myeloid",
                "t_cells",
                "cafs",
                "b_cells"],
          selectedMode: "single", // 单选
          selected:{
            'normal_Epithelial': true,
            'cancer_Epithelial': false,
            'endothelial': false,
            'pvl': false,
            'plasmablasts': false,
            'myeloid': false,
            't_cells': false,
            'cafs': false,
            'b_cells': false
          },
          textStyle: {
            fontSize: 10
          }
        },
        grid: {
          left: '15%',
          right: '15%',
          top: '5%',
          bottom: '5%'
        },
        tooltip: {
          backgroundColor: 'rgba(255,255,255,0.7)',
          formatter: function (param) {
            // console.log(param)
            var value = param.value;
            // prettier-ignore
            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                + param.seriesName
                + '</div>'
                // + schema[0].text + '：' + value[2] + '<br>'
                + schema[1].text + '：' + value[0] + '<br>'
                + schema[2].text + '：' + value[1] + '<br>'
                + schema[3].text + '：' + value[3] + '<br>'
                + schema[4].text + '：' + value[4] + '<br>';
          }
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        visualMap: [
          // {
          //   left: 'right',
          //   top: '10%',
          //   dimension: 2,
          //   min: 0,
          //   max: 250,
          //   itemWidth: 30,
          //   itemHeight: 120,
          //   calculable: true,
          //   precision: 0.1,
          //   text: ['圆形大小：PM2.5'],
          //   textGap: 30,
          //   inRange: {
          //     symbolSize: [10, 70]
          //   },
          //   outOfRange: {
          //     symbolSize: [10, 70],
          //     color: ['rgba(255,255,255,0.4)']
          //   },
          //   controller: {
          //     inRange: {
          //       color: ['#c23531']
          //     },
          //     outOfRange: {
          //       color: ['#999']
          //     }
          //   }
          // },
          {
            left: 'right',
            bottom: '30%',
            dimension: 4,
            type: 'continuous',
            calculable:true,                        //是否显示拖拽用的手柄（手柄能拖拽调整选中范围）
            realtime:true,                          //拖拽时，是否实时更新
            precision:3,                            //数据展示的小数精度，默认为0，无小数点
            min: 0,
            max: 1,
            itemHeight: 120,
            align:"auto",
            text: ['expression'],
            textGap: 30,
            inRange: {
              // colorLightness: [1, 0.4],
              color: ['gray','blue']
            },
            outOfRange: {
              color: ['rgba(255,255,255,0.4)']
            },
            controller: {
              inRange: {
                color: ['gray','blue']
                // color: ['#c23531']
                // color: ['#FFFFFF']
              },
              outOfRange: {
                color: ['#999']
              }
            }
          }
        ],
        series: [
          {
            type: 'scatter',
            itemStyle: itemStyle,
            large: true,                //是否开启大规模散点图的优化，在数据图形特别多的时候（>=5k）可以开启。开启后配合 largeThreshold 在数据量大于指定阈值的时候对绘制进行优化。缺点：优化后不能自定义设置单个数据项的样式。
            largeThreshold:5000,        //开启绘制优化的阈值。
            data: this.list_data.normal_Epithelial,
            symbolSize: 5,
            name: 'normal_Epithelial',
          },
          {
            name: 'cancer_Epithelial',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.list_data.cancer_Epithelial,
            symbolSize: 5
          },
          {
            name: 'endothelial',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.list_data.endothelial,
            symbolSize: 5
          },
          {
            name: 'pvl',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.list_data.pvl,
            symbolSize: 5
          },
          {
            name: 'plasmablasts',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.list_data.plasmablasts,
            symbolSize: 5
          },
          {
            name: 'myeloid',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.list_data.myeloid,
            symbolSize: 5
          },
          {
            name: 't_cells',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.list_data.t_cells,
            symbolSize: 5
          },
          {
            name: 'cafs',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.list_data.cafs,
            symbolSize: 5
          },
          {
            name: 'b_cells',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.list_data.b_cells,
            symbolSize: 5
          }
        ]
      };
      myChart.off('legendselectchanged') //解决重复触发
      myChart.on('legendselectchanged', function (params) {
        console.log('点击了', params.name);
        _this.type = params.name;
        // _this.getStateData();
        // myChart.setOption({
        //   legend:{selected:{[params.name]: true}}
        // })
        // do something
        _this.changeSelect()
      });
      option && myChart.setOption(option);

    },
    changeSelect(index) {
      let _this = this
      let elementID = "rctd_vue"+index
      console.log(elementID)
      const myChart = echarts.getInstanceByDom(document.getElementById(elementID));
      let option;
      const itemStyle = {
        emphasis: {
          focus : 'self'
        }
      };
      myChart.setOption({
        legend: {selected: {[_this.type]: true}},
        series: [
          {
            type: 'scatter',
            itemStyle: itemStyle,
            large: true,                //是否开启大规模散点图的优化，在数据图形特别多的时候（>=5k）可以开启。开启后配合 largeThreshold 在数据量大于指定阈值的时候对绘制进行优化。缺点：优化后不能自定义设置单个数据项的样式。
            largeThreshold:5000,        //开启绘制优化的阈值。
            data: this.list_data.normal_Epithelial,
            symbolSize: 5,
            name: 'normal_Epithelial',
          },
          {
            name: 'cancer_Epithelial',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.list_data.cancer_Epithelial,
            symbolSize: 5
          },
          {
            name: 'endothelial',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.list_data.endothelial,
            symbolSize: 5
          },
          {
            name: 'pvl',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.list_data.pvl,
            symbolSize: 5
          },
          {
            name: 'plasmablasts',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.list_data.plasmablasts,
            symbolSize: 5
          },
          {
            name: 'myeloid',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.list_data.myeloid,
            symbolSize: 5
          },
          {
            name: 't_cells',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.list_data.t_cells,
            symbolSize: 5
          },
          {
            name: 'cafs',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.list_data.cafs,
            symbolSize: 5
          },
          {
            name: 'b_cells',
            type: 'scatter',
            itemStyle: itemStyle,
            data: this.list_data.b_cells,
            symbolSize: 5
          }
        ]
      })
      // chartDom.setAttribute('_echarts_instance_', '')
      option && myChart.setOption(option,true);
    },
    isImgExist(){
      let _this = this
      for(let i = 0; i < _this.classification.length; i++) {
        if(_this.classification[i].num !== 0){
          _this.haveClassification = true
          break
        }
      }
      if (_this.haveClassification == false) {
        _this.activeName1 = 'second1'
      }
      for(let i = 0; i < _this.communication.length; i++) {
        if(_this.communication[i].num !== 0){
          _this.haveCommunication = true
          break
        }
      }
      for(let i = 0; i < _this.MIF.length; i++) {
        if(_this.MIF[i].num !== 0){
          _this.haveMIF = true
          break
        }
      }
      for(let i = 0; i < _this.major.length; i++) {
        if(_this.major[i].num !== 0){
          _this.haveMajor = true
          _this.Label_transfer += 1
          break
        }
      }
      for(let i = 0; i < _this.minor.length; i++) {
        if(_this.minor[i].num !== 0){
          _this.haveMinor = true
          _this.Label_transfer += 1
          break
        }
      }
      for(let i = 0; i < _this.subset.length; i++) {
        if(_this.subset[i].num !== 0){
          _this.haveSubset = true
          _this.Label_transfer += 1
          break
        }
      }
      for(let i = 0; i < _this.annotation.length; i++) {
        if(_this.annotation[i].num !== 0){
          _this.haveAnnotation = true
          break
        }
      }
      for(let i = 0; i < _this.interaction.length; i++) {
        if(_this.interaction[i].num !== 0){
          _this.haveInteraction = true
          break
        }
      }
      console.log("label_transfer:"+_this.Label_transfer)
      console.log("haveClassification:"+_this.haveClassification)
      console.log("haveCommunication:"+_this.haveCommunication)
      console.log("haveMIF:"+_this.haveMIF)
      console.log("haveMajor:"+_this.haveMajor)
      console.log("haveMinor:"+_this.haveMinor)
      console.log("haveSubset:"+_this.haveSubset)
      console.log("haveAnnotation:"+_this.haveAnnotation)
      console.log("haveInteraction:"+_this.haveInteraction)
    },
    changeJSONObject2Array(index, name){
      let _this = this
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/celltype/position/'+ _this.$route.params.id+'/'+ name)
          .then(function (response){
            let x = response.data.x
            let y = response.data.y
            let res = {}
            for (let type in _this.type2){
              let temp_type = _this.type2[type]
              let res_list = []
              for (let temp in _this.RCTD[index].data) {
                let temp_array = _this.RCTD[index].data[temp]
                let res_array = []
                res_array.push(x[temp])
                res_array.push(y[temp])
                res_array.push(Number(temp))
                res_array.push(temp_array['spot'])
                res_array.push(temp_array[temp_type])
                res_list.push(res_array)
              }
              res[temp_type] = res_list
            }
            _this.list_data = res
            console.log(_this.list_data)
            _this.changeSelect(index)
          })
      // console.log("list_data:" + _this.list_data)
    },
    handleSizeChange0(val) {
      console.log(`每页 ${val} 条`);
      this.pageinfo[0].currentPage = 1;
      this.pageinfo[0].pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange0(val) {
      console.log(`当前页: ${val}`);
      this.pageinfo[0].currentPage = val;
    },
    handleSizeChange1(val) {
      console.log(`每页 ${val} 条`);
      this.pageinfo[1].currentPage = 1;
      this.pageinfo[1].pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange1(val) {
      console.log(`当前页: ${val}`);
      this.pageinfo[1].currentPage = val;
    },
    handleSizeChange2(val) {
      console.log(`每页 ${val} 条`);
      this.pageinfo[2].currentPage = 1;
      this.pageinfo[2].pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange2(val) {
      console.log(`当前页: ${val}`);
      this.pageinfo[2].currentPage = val;
    },
    handleSizeChange3(val) {
      console.log(`每页 ${val} 条`);
      this.pageinfo[3].currentPage = 1;
      this.pageinfo[3].pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange3(val) {
      console.log(`当前页: ${val}`);
      this.pageinfo[3].currentPage = val;
    },
    handleSizeChange4(val) {
      console.log(`每页 ${val} 条`);
      this.pageinfo[4].currentPage = 1;
      this.pageinfo[4].pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange4(val) {
      console.log(`当前页: ${val}`);
      this.pageinfo[4].currentPage = val;
    },
    handleSizeChange5(val) {
      console.log(`每页 ${val} 条`);
      this.pageinfo[5].currentPage = 1;
      this.pageinfo[5].pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange5(val) {
      console.log(`当前页: ${val}`);
      this.pageinfo[5].currentPage = val;
    },
    handleSizeChange6(val) {
      console.log(`每页 ${val} 条`);
      this.pageinfo[6].currentPage = 1;
      this.pageinfo[6].pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange6(val) {
      console.log(`当前页: ${val}`);
      this.pageinfo[6].currentPage = val;
    },
    handleSizeChange7(val) {
      console.log(`每页 ${val} 条`);
      this.pageinfo[7].currentPage = 1;
      this.pageinfo[7].pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange7(val) {
      console.log(`当前页: ${val}`);
      this.pageinfo[7].currentPage = val;
    },
    handleSizeChange8(val) {
      console.log(`每页 ${val} 条`);
      this.pageinfo[8].currentPage = 1;
      this.pageinfo[8].pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange8(val) {
      console.log(`当前页: ${val}`);
      this.pageinfo[8].currentPage = val;
    },
    handleSizeChange9(val) {
      console.log(`每页 ${val} 条`);
      this.pageinfo[9].currentPage = 1;
      this.pageinfo[9].pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange9(val) {
      console.log(`当前页: ${val}`);
      this.pageinfo[9].currentPage = val;
      console.log(this.pageinfo[9].currentPage)
    },
    handleSizeChange10(val) {
      console.log(`每页 ${val} 条`);
      this.pageinfo[10].currentPage = 1;
      this.pageinfo[10].pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange10(val) {
      console.log(`当前页: ${val}`);
      this.pageinfo[10].currentPage = val;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    rounding(row,column) {
      return parseFloat(row[column.property]).toFixed(8)
    },
    getMaxV(distributionInfo) {
      let max = 0
      for (let item of distributionInfo) {
        console.log(distributionInfo[item])
        if (max < Number(distributionInfo[item])){
          max = Number(distributionInfo[item])
        }
      }
      return max
    },
    // 获取最小值
    getMinV(distributionInfo) {
      let min = 1000000
      for (let item of distributionInfo) {
        if (min > Number(distributionInfo[item])){
          min = Number(distributionInfo[item])
        }
      }
      return min
    },
    // 归一化处理
    normalization(distributionInfo) {
      let result = []
      let max = Math.max(...distributionInfo)
      let min = Math.min(...distributionInfo) - 10
      console.log('max:'+max)
      console.log('min:'+min)
      for (let item of distributionInfo) {
        result.push((item - min) / (max - min))
      }
      return result
    }
  }
}
</script>

<style scoped>
.hide-img{
  display: none;
}
</style>
